export const SERVICE_ONE_TO_ONE_CHECKOUT_FLOW = 'service_one_to_one';

export const SERVICE_BOOKING_ANALYTICS_EVENT = {
  BOOKING_HELD: 'service.booking.held',
  BOOKING_CONFIRMED: 'service.booking.confirmed',
  BOOKING_CANCELLED: 'service.booking.cancelled',
} as const;

export function buildBookingIcs(params: {
  uid: string;
  title: string;
  description?: string;
  startsAt: Date;
  endsAt: Date;
  location?: string | null;
  organizerEmail?: string | null;
  attendeeEmail?: string | null;
}): string {
  const format = (date: Date) =>
    date
      .toISOString()
      .replace(/[-:]/g, '')
      .replace(/\.\d{3}Z$/, 'Z');

  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Loamify//Services//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:REQUEST',
    'BEGIN:VEVENT',
    `UID:${params.uid}`,
    `DTSTAMP:${format(new Date())}`,
    `DTSTART:${format(params.startsAt)}`,
    `DTEND:${format(params.endsAt)}`,
    `SUMMARY:${escapeIcsText(params.title)}`,
  ];

  if (params.description) lines.push(`DESCRIPTION:${escapeIcsText(params.description)}`);
  if (params.location) lines.push(`LOCATION:${escapeIcsText(params.location)}`);
  if (params.organizerEmail) lines.push(`ORGANIZER:mailto:${params.organizerEmail}`);
  if (params.attendeeEmail) lines.push(`ATTENDEE:mailto:${params.attendeeEmail}`);

  lines.push('END:VEVENT', 'END:VCALENDAR');
  return lines.join('\r\n');
}

function escapeIcsText(value: string) {
  return value.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
}

export function slotsOverlap(
  aStart: Date,
  aEnd: Date,
  bStart: Date,
  bEnd: Date,
  bufferMinutes = 0,
): boolean {
  const bufferMs = bufferMinutes * 60_000;
  return aStart.getTime() < bEnd.getTime() + bufferMs && bStart.getTime() - bufferMs < aEnd.getTime();
}
